import { Component, EventEmitter, Input, Output, OnDestroy, OnInit } from '@angular/core';
import { IClient } from '../../../../../core/models/clients.models';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { ClientsApiService } from '../../../../clients/clients.apiservice';
import { CAMPAIGN_STUDIO_STATUS } from '../../../../../core/helpers/constants';

@Component({
  selector: 'app-new-campaign-form',
  templateUrl: './new-campaign-form.component.html',
  styleUrls: ['./new-campaign-form.component.scss']
})
export class NewCampaignFormComponent implements OnDestroy, OnInit {

  public CAMPAIGN_STUDIO_STATUS = CAMPAIGN_STUDIO_STATUS;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  tempClients = new Array<IClient>();

  @Input() campForm!: FormGroup; 
  @Input() clientsData = new Array<IClient>();
  @Input() selectedClient: IClient = {} as IClient;
  @Input() addingFacebook: boolean = false;

  @Output() changeCampaign = new EventEmitter<boolean>();
  @Output() submitCampForm = new EventEmitter<FormGroup>(); 
  @Output() changeClient = new EventEmitter<IClient>(); 

  brandPlaceholder: string = '';
  attemptClick: boolean = false;
  isCustomCrmName = false;
  public defaultCRMNames = [
    { title: 'ClubReady', value: 'ClubReady' },
    { title: 'MindBody', value: 'Mindbody' },
    { title: 'Loyalsnap', value: 'Loyalsnap' },
    { title: 'Glofox', value: 'Glofox' },
    { title: 'Mariana Tek', value: 'Mariana Tek' },
    { title: 'Other', value: 'Other' },
  ];

  studioStages = [
    { id: '0', name: 'Sustained' },
    { id: '1', name: 'Presale' },
  ]

  constructor(
    private clientService: ClientsApiService,
  ) {}

  ngOnInit(): void {
    
    if (this.selectedClient && this.selectedClient.id) {
      this.tempClients = [this.selectedClient];
      this.campForm.get('clientId')?.setValue(this.selectedClient.id);
      this.changeCompanyFill({ id: this.selectedClient.id });
    } else {
      this.tempClients = this.clientsData;
      const clientId = this.campForm?.get('clientId')?.value;
      if (clientId) {
        this.campForm.get('clientId')?.setValue(null);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  changeSelection(event: boolean) {
    this.changeCampaign.emit(event);
  }

  onSubmit() {
    this.trimFormValues(this.campForm);
    const phoneControl = this.campForm.get('studioPhone');
    if (typeof phoneControl?.value === 'string' && phoneControl.value.length > 20) {
      phoneControl.setErrors({
        ...phoneControl.errors,
        maxlength: {
          requiredLength: 20,
          actualLength: phoneControl.value.length
        }
      });
    }

    if (this.campForm.valid) {
      this.attemptClick = false;
      this.submitCampForm.emit(this.campForm);
    } else {
      this.attemptClick = true;
      this.campForm.markAllAsTouched(); // Highlight all invalid fields
    }
  }

  private trimFormValues(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control && control.value && typeof control.value === 'string') {
        control.setValue(control.value.trim());
      }
    });
  }

  onNameChange(evt: any) {
    const a = this.campForm.get('brandName')?.value || '';
    const b = this.campForm.get('studioLocationName')?.value || '';
    this.campForm.get('campaignName')?.setValue(a + ' ' + b);
  }

  clientFilterChange(evt: any) {
    this.selectedClient = evt;
    this.changeClient.emit(evt);
  }

  changeCompanyFill(evt: any) {
    // this.changeClient.emit(evt);
    this.clientService.getClientDetails(evt.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.brandPlaceholder = response.data.brand;
        this.campForm.get('brandName')?.setValue(response.data.brand);
        this.onNameChange(evt);
      });
  }

  // Add this method to handle CRM dropdown changes
  onCrmNameChange(event: any) {
    if (event === 'Other') {
      this.isCustomCrmName = true;
      this.campForm.get('crmName')?.setValue('');
    } else {
      this.isCustomCrmName = false;
      this.campForm.get('crmName')?.setValue(event);
    }
  }

  // Returns true if all required fields are filled and valid
  isRequiredFieldsFilled(): boolean {
    const requiredFields = [
      'clientId',
      'brandName',
      'studioLocationName',
      'studioEmail',
      'studioPhone',
      'studioStreet',
      'studioCity',
      'studioState',
      'studioZipcode'
    ];
    for (const field of requiredFields) {
      const control = this.campForm.get(field);
      const hasValue = typeof control?.value === 'string'
        ? control.value.trim() !== ''
        : control?.value !== null && control?.value !== undefined && control.value !== '';

      if (!control || !hasValue) {
        return false;
      }
    }
    return true;
  }
}